import { FormState, FieldState } from 'formstate'
import { required, onlyNumeric, cantBeZero } from '../../utils/forms'

class SendCreditForm {
  fields = {
    amount: new FieldState('').validators(required, onlyNumeric, cantBeZero),
  }

  form = new FormState(this.fields)

  serialize = () => {
    return {
      amount: this.fields.amount.$,
    }
  }
}

export { SendCreditForm }
